import { render, staticRenderFns } from "./dm.vue?vue&type=template&id=fa7c942e&scoped=true"
import script from "./dm.vue?vue&type=script&lang=js"
export * from "./dm.vue?vue&type=script&lang=js"
import style0 from "./dm.vue?vue&type=style&index=0&id=fa7c942e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa7c942e",
  null
  
)

export default component.exports